import styled from '@emotion/styled';
import { IBreadcrumbProps } from '@shared/models/components/IBreadcrumb';
import { NavLink } from 'react-router';
import { MixinTypographyBodyMedium } from '../text/Typography';
import { MixinFocusVisible } from './DefaultStyles';

// TODO V3: Update breadcrumb to useMatches see #1360

export default function Breadcrumb({ items }: IBreadcrumbProps) {
    return (
        <BreadcrumbNav aria-label="Breadcrumb">
            <BreadcrumbList>
                {items.map((item, index) => (
                    <BreadcrumbItem key={index}>
                        {index < items.length - 1 ? (
                            <BreadcrumbLink viewTransition to={item.href}>
                                {item.label}
                            </BreadcrumbLink>
                        ) : (
                            <span aria-current="page">{item.label}</span>
                        )}
                    </BreadcrumbItem>
                ))}
            </BreadcrumbList>
        </BreadcrumbNav>
    );
}

// Styled components
const BreadcrumbNav = styled.nav`
    ${MixinTypographyBodyMedium}
    display: flex;
    align-items: center;
    justify-content: flex-start;
    color: ${({ theme }) => theme.color.textBody};
    position: sticky;
    top: 0;
    z-index: 1000;
    padding: 0.5rem 0 0 0;
    width: 100%;
    background-color: ${({ theme }) => theme.color.background};
`;

const BreadcrumbList = styled.ol`
    display: flex;
    flex-wrap: wrap;
    list-style: none;
    padding: 0;
    margin: 0;
`;

const BreadcrumbItem = styled.li`
    display: flex;
    align-items: center;

    &::after {
        content: '/';
        margin: 0 0.5rem;
        color: ${({ theme }) => theme.color.border};
    }

    &:last-child::after {
        content: '';
    }
`;

const BreadcrumbLink = styled(NavLink)`
    text-decoration: none;
    color: ${({ theme }) => theme.color.link};

    &:hover,
    &:focus {
        text-decoration: underline;
        outline: none;
    }

    ${MixinFocusVisible}
`;
